<template>
  <el-row>
    <el-carousel
      v-if="list.length > 0"
      trigger="click"
      :height="carouselHeight"
      :autoplay="false"
      indicator-position="none"
      arrow="always"
      @change="change"
    >
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <el-row class="height-100 item-box" :gutter="30">
          <el-col
            v-for="ite in item"
            :key="ite.id"
            :span="8"
            class="height-100 card-box"
          >
            <el-row
              class="height-100 card"
              :class="[{ active: ite.choose }]"
              @click.native="chooseIte(ite)"
            >
              <el-row>
                <div class="pro-name">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ ite.projectName }}</span>
                      <br />
                      <span>{{ ite.contractName }}</span>
                      <br />
                      <span>{{ ite.contractCode }}</span>
                    </div>
                    <el-button type="text">
                      {{ ite.projectName }}
                    </el-button>
                  </el-tooltip>
                </div>
                <p class="con-name" alt="123123">
                  {{ ite.contractName }}
                </p>
                <p class="mt-8 mb-0">
                  <span class="label">
                    项目负责人
                  </span>
                  <span>
                    {{ ite.principalName }}
                  </span>
                </p>
              </el-row>
              <el-row class="bottom">
                <p>
                  <span class="label">
                    合同类型
                  </span>
                  <span>
                    <span v-if="ite.contractType === 'LWJS'">
                      分包结算
                    </span>
                    <span v-if="ite.contractType === 'ZLJS'">
                      租赁合同
                    </span>
                    <span v-if="ite.contractType === 'CLJS'">
                      材料合同
                    </span>
                    <span v-if="ite.contractType === 'QTJS'">
                      其他合同
                    </span>
                  </span>
                </p>
                <p>
                  <span class="label">
                    合同金额
                  </span>
                  <span> {{ ite.contractMoney | toTenThousand }} 万元 </span>
                </p>
                <p v-if="showItems.showSettlement">
                  <span class="label">
                    累计结算金额
                  </span>
                  <span>
                    {{ ite.totalSettlementAmount | toTenThousand }} 万元
                  </span>
                </p>
                <p v-if="showItems.showPayment">
                  <span class="label">
                    累计付款金额
                  </span>
                  <span>
                    {{ ite.totalPaymentAmount | toTenThousand }} 万元
                  </span>
                </p>
                <p v-if="showItems.showPaymentLimit">
                  <span class="label">
                    可申请付款金额
                  </span>
                  <span> {{ ite.paymentLimit | toTenThousand }} 万元 </span>
                </p>
              </el-row>
              <label v-show="ite.choose" class="choose-box">
                <i class="el-icon-check"></i>
              </label>
            </el-row>
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>
    <p v-if="list.length > 0" class="page align-center">
      <span>
        {{ initial }}/
        {{ list.length }}
      </span>
    </p>
    <el-col v-else>
      <p class="align-center data-empty">
        暂无数据
      </p>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showItems() {
      const data = this.$store.state.configMap
      const obj = {
        showSettlement: data.show_settlement_amount.configValue==='1'?true:false, // 是否显示合同累计结算金额
        showPayment: data.show_payment_amount.configValue==='1'?true:false, // 是否显示合同累计付款金额
        showPaymentLimit: data.show_payment_limit.configValue==='1'?true:false
      }
      return obj 
    },
    carouselHeight() {
      let height = 340
      let tag = 0
      const data = this.$store.state.configMap
      const obj = {
        showSettlement: data.show_settlement_amount.configValue==='1'?true:false, // 是否显示合同累计结算金额
        showPayment: data.show_payment_amount.configValue==='1'?true:false, // 是否显示合同累计付款金额
        showPaymentLimit: data.show_payment_limit.configValue==='1'?true:false
      }
      for (let key in obj) {
        if (!obj[key]) {
          tag ++
        }
      }
      height = height - (30 * tag)
      return `${height}px`
    }
  },
  data() {
    return {
      initial: 1,
      map: {},
      list: [],
      chooseType: null // 选中的合同类型
    }
  },
  watch: {
    data() {
      this.initState()
    }
  },
  mounted() {
    this.initState()
  },
  methods: {
    initState() {
      if (this.data.length > 0) {
        this.initData()
      } else {
        this.list = []
      }
    },
    initData() {
      this.list = []
      // console.log('this.data', this.data)
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].choose) {
          this.chooseType = this.data[i].contractType
        }
      }
      for (let i = 0; i < this.data.length; i = i + 3) {
        // console.log('this.chooseType', this.chooseType)
        const arr = this.data.slice(i, i + 3)
        arr.forEach(item => {
          this.map[item.contractCode] = item // 建立映射
        })
        this.list.push(arr)
      }
    },
    change(val) {
      this.initial = val + 1
    },
    chooseIte(ite) {
      if (this.disabled) {
        return
      }
      // 如果是单选 则先将所有清空
      if (!this.multiple) {
        this.data.forEach(item => {
          if (item.id !== ite.id) {
            item.choose = false
          }
        })
      } else {
        if (this.chooseType && this.chooseType !== ite.contractType) {
          this.$alert(
            '该合同与已选合同的合同类型不一致，请确认后重新选择',
            '提示',
            {
              confirmButtonText: '确定'
            }
          )
          return
        }
        this.chooseType = ite.contractType
      }
      ite.choose = !ite.choose
      // 多选的话在状态修改后 判断选中状态数量
      // 为零则将chooseType改为null
      let tag = 0
      this.list.forEach(item => {
        item.forEach(ite => {
          if (ite.choose) tag++
        })
      })
      if (tag === 0) {
        this.chooseType = null
      }
      this.$emit('choose', ite)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-box {
  margin-left: 40px !important;
  margin-right: 40px !important;
  .card-box {
    .card {
      position: relative;
      width: 260px;
      height: auto;
      margin-top: 5px;
      padding: 20px 12px 5px;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      overflow: hidden;
      cursor: pointer;
      &:before {
        content: '';
        position: absolute;
        left: -4px;
        width: 8px;
        height: 19px;
        border-radius: 4px;
        background: $primary;
      }
      .pro-name {
        margin: 0;
        font-size: 0.875rem;
        font-weight: bold;
      }
      .con-name {
        margin: 10px 0 0;
        font-size: 0.875rem;
        color: #666;
      }
      .label {
        display: inline-block;
        width: 120px;
        color: $primary;
      }
      .label + span {
        color: $primary;
      }
      .bottom {
        padding-top: 16px;
        p {
          margin: 0;
          display: flex;
          justify-content: space-between;
          padding-top: 10px;
          padding-bottom: 10px;
          border-bottom: 1px solid #e8e8e8;
          .label {
            color: #828584;
          }
          &:last-child {
            border: none;
          }
          span {
            font-size: 0.875rem;
            &:last-child {
              font-weight: bold;
              color: $primary;
            }
          }
        }
      }
    }
    .active {
      background: #eaf4ff;
    }
  }
}
.choose-box {
  position: absolute;
  right: -17px;
  top: -25px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: $primary;
  i {
    position: absolute;
    top: 45%;
    left: 13px;
    color: white;
    font-size: 25px;
    font-weight: bold;
  }
}
.page {
  font-size: 0.875rem;
}
.data-empty {
  margin: 0;
  height: 240px;
  line-height: 240px;
}
.pro-name,
.con-name {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep {
  .el-button--text {
    margin: 0;
    color: black;
    line-height: 0;
    font-size: 0.875rem;
    font-weight: bold;
  }
  .el-carousel__arrow--right {
    right: 0;
  }
  .el-carousel__arrow--left {
    left: 0;
  }
  .el-carousel__arrow {
    background-color: transparent;
    color: #8a8a8a;
    font-size: 36px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
